import { useCallback } from "react";
import { ManageThreadsApi, useAPIAction } from "melco-shared-logic";

export const useDeleteThread = (threadIdToDelete?: string) => {
    const [deleteThread] = useAPIAction(
        ManageThreadsApi,
        async (api) => {

            const data = await api.threadsDelete({
                "id": threadIdToDelete ?? ""
            });

            return {
                successMessages: [{ message: "default" },],
                data,
            };
        },
        {
            translationPrefix: "managethreads.actions.delete",

        }
    );

    return useCallback(
        async () => {

            await deleteThread();


            return { success: true };
        },
        [deleteThread]
    );
};
